const trimSlash = (value = "") => value.replace(/\/+$/, "");

export const API_BASE_URL = trimSlash(
  process.env.REACT_APP_API_BASE_URL || "https://arabella-backend.vercel.app/api"
);

export const CLOUDINARY_CLOUD_NAME = (
  process.env.REACT_APP_CLOUDINARY_CLOUD_NAME ||
  process.env.REACT_APP_CLOUDINARY_NAME ||
  ""
).trim();

export const CLOUDINARY_UPLOAD_PRESET = (
  process.env.REACT_APP_CLOUDINARY_UPLOAD_PRESET || ""
).trim();

export const CLOUDINARY_FOLDER = (
  process.env.REACT_APP_CLOUDINARY_FOLDER || "arabella/blogs"
).trim();

export const isCloudinaryConfigured = Boolean(
  CLOUDINARY_CLOUD_NAME && CLOUDINARY_UPLOAD_PRESET
);
